import moment from 'moment';
import _ from 'lodash';

import payoutBalanceService from 'src/api/payoutBalance';
import payoutService from 'src/api/payout';

function PerformancePayoutsCtrl($scope, $q, organizationService, managementUserOrganizationMemberService, venueService, permissionService, alertService, sdkUtils, $timeout, dateUtilsService) { //eslint-disable-line
  const currentUserOrganization = organizationService.getCurrentOrganization();

  $scope.filterUsersForm = {
    venue: null
  };

  $scope.currentDateUTC = moment.utc();

  $scope.initialLoad = true;

  $scope.$watchGroup(['filterUsersForm.venue'], () => {
    if ($scope.initialLoad) return;

    $scope.getPayoutBalance();
    $scope.getPayouts();
  });

  $scope.getPayoutBalance = function() {
    $scope.payoutBalanceLoading = true;

    if (!$scope.filterUsersForm.venue.paymentProviderAccountId) {
      return null;
    }

    return $q.resolve(payoutBalanceService.listByVenueId($scope.filterUsersForm.venue.id))
      .then(response => {
        $scope.payoutBalance = (response.data || [])[0];
      })
      .catch(response => alertService.error(sdkUtils.getErrorFromResponse(response)))
      .finally(() => {
        $scope.payoutBalanceLoading = false;
      });
  };

  $scope.getPayouts = function() {
    $scope.payoutsLoading = true;

    if (!$scope.filterUsersForm.venue.paymentProviderAccountId) {
      return null;
    }

    return $q.resolve(payoutService.listByVenueId($scope.filterUsersForm.venue.id))
      .then(response => {
        $scope.payouts = response.data.map(payout => {
          payout.arrivalDate = moment.utc(payout.arrivalDate);

          return payout;
        });
      })
      .catch(response => alertService.error(sdkUtils.getErrorFromResponse(response)))
      .finally(() => {
        $scope.payoutsLoading = false;
      });
  };

  _getVenues()
    .then(() => {
      $scope.getPayoutBalance();
      $scope.getPayouts();
    })
    .finally(() => {
      $timeout(() => {
        $scope.initialLoad = false;
      }, 500);
    });

  function _getVenues() {
    $scope.venuesLoading = true;

    return venueService.listByOrganizationId(currentUserOrganization.id, {
        fields: 'name, id, paymentProviderAccountId'
      })
      .then(venues => {
        const permissionPromises = venues.map(venue => {
          return permissionService.canWriteVenue(venue.id)
            .then(hasPermission => {
              if (!hasPermission) {
                venues = _.filter(venues, v => {
                  return v.id !== venue.id;
                });
              }
            });
        });

        return $q.all(permissionPromises)
          .then(() => {
            $scope.venues = venues;

            if (!$scope.venues.length) {
              $scope.noPermission = true;
              return;
            }

            $scope.filterUsersForm.venue = $scope.venues[0];

            return venues; //eslint-disable-line
          });
      })
      .catch(response => {
        alertService.error(sdkUtils.getErrorFromResponse(response));
      })
      .finally(() => {
        $scope.venuesLoading = false;
      });
  }
}

PerformancePayoutsCtrl.$inject = [
  '$scope',
  '$q',
  'organizationService',
  'managementUserOrganizationMemberService',
  'jsSdk.venue',
  'permissionService',
  'alertService',
  'jsSdk.utils',
  '$timeout',
  'dateUtilsService'
];

export default PerformancePayoutsCtrl;



// WEBPACK FOOTER //
// ./src/components/performancePayouts/performancePayoutsCtrl.js